import { useTheme } from '@/contexts/ThemeContext';
import {
  Menu,
  Moon,
  Sun,
  ShieldCheck,
  Search,
  Bell,
  Grid,
} from 'lucide-react';

interface AdminHeaderProps {
  title: string;
  subtitle?: string;
  onMenuClick: () => void;
}

const AdminHeader = ({ title, subtitle, onMenuClick }: AdminHeaderProps) => {
  const { resolvedTheme, toggleTheme } = useTheme();

  return (
    <header className="fixed top-0 right-0 lg:left-[260px] left-0 h-16 bg-card border-b border-border z-30 flex items-center transition-all duration-300">
      <div className="flex-1 h-full flex items-center px-4 lg:px-6">
        
        {/* Mobile Sidebar Toggle */}
        <button
          onClick={onMenuClick}
          className="w-10 h-10 flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-muted rounded-lg transition-colors lg:hidden mr-2"
        >
          <Menu className="w-5 h-5" />
        </button>

        {/* Page Title (Hidden on small screens) */}
        <div className="hidden sm:flex flex-col">
          <h1 className="text-sm font-semibold text-foreground tracking-tight">{title}</h1>
          {subtitle && (
            <p className="text-[11px] text-muted-foreground">{subtitle}</p>
          )}
        </div>

        {/* Right Actions */}
        <div className="flex items-center gap-1 sm:gap-2 ml-auto">
          <button className="w-10 h-10 flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-muted rounded-lg transition-colors">
            <Search className="w-5 h-5" />
          </button>
          
          <button className="w-10 h-10 flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-muted rounded-lg transition-colors relative">
            <Bell className="w-5 h-5" />
            <span className="absolute top-2 right-2 w-2 h-2 bg-destructive rounded-full"></span>
          </button>
          
          <button className="hidden sm:flex w-10 h-10 items-center justify-center text-muted-foreground hover:text-foreground hover:bg-muted rounded-lg transition-colors">
            <Grid className="w-5 h-5" />
          </button>

          {/* Theme Toggle */}
          <button
            onClick={toggleTheme}
            className="w-10 h-10 flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-muted rounded-lg transition-colors ml-1"
          >
            {resolvedTheme === 'dark' ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
          </button>

          {/* User Avatar */}
          <div className="relative ml-1 sm:ml-2">
            <button className="w-9 h-9 rounded-full bg-muted flex items-center justify-center ring-2 ring-background overflow-hidden">
               <ShieldCheck className="w-5 h-5 text-primary" />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
